export default __webpack_public_path__ + "static/media/popover-position-bottom.b886a908.svg";